import { GatewayChargingSessionModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/outputs/charging-sessions/gateway-charging-session.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { EmspBoChargingSessionListLocationSubOperatorNameCell } from './emsp-bo-charging-session-list-location-sub-operator-name.cell';
import { EmspBoChargingSessionListLocationSubOperatorNameHeader } from './emsp-bo-charging-session-list-location-sub-operator-name.header';

export const EmspBoChargingSessionListLocationSubOperatorNameColumn: IdentifiedColumnDef<
  GatewayChargingSessionModel,
  GatewayChargingSessionModel['locationSubOperatorName']
> = {
  enableSorting: false,
  header: EmspBoChargingSessionListLocationSubOperatorNameHeader,
  cell: EmspBoChargingSessionListLocationSubOperatorNameCell,
  meta: { maxWidth: '110px', width: '80px', minWidth: '60px' },
};
